<div class="calendar-container">
  <p-toast></p-toast>
  <!-- Calendar Header -->
  <div class="calendar-header">
    <div class="calendar-title">
      <h1>{{ getCurrentMonth() }} {{ getCurrentYear() }}</h1>
    </div>
    
    <!-- <div class="calendar-controls">
      <p-button appGlobalLoadingDisable 
        label="Schedule Interaction" 
        icon="pi pi-plus" 
        styleClass="p-button-primary"
        (onClick)="scheduleInteraction()">
      </p-button>
    </div> -->
  </div>

  <!-- Main Calendar Area -->
  <div class="calendar-main">
    <!-- Calendar Grid -->
    <div class="calendar-grid">
      <div *ngIf="isLoading" class="loading-overlay">
        <div class="loading-spinner">Loading interactions...</div>
      </div>
      <div class="calendar-wrapper">
        <full-calendar #calendar [options]="calendarOptions"></full-calendar>
      </div>
    </div>

    <!-- Right Sidebar -->
    <div class="calendar-sidebar">
      <!-- Integrations Section -->
      <div class="integrations-section">
        <h3>Sync with your calendar</h3>
        <div class="sync-buttons">
          <button class="sync-btn google" (click)="syncWithGoogle()" [disabled]="isSyncing">
            <svg *ngIf="!isSyncing" class="google-icon" viewBox="0 0 24 24">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285f4"/>
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34a853"/>
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#fbbc04"/>
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#ea4335"/>
            </svg>
            <svg *ngIf="isSyncing" class="spinner" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 12a9 9 0 11-6.219-8.56"/>
            </svg>
            {{ isSyncing ? 'Syncing...' : 'Sync with Google Calendar' }}
          </button>
          
          <button class="sync-btn outlook" (click)="syncWithOutlook()">
            <svg class="outlook-icon" viewBox="0 0 24 24">
              <rect width="24" height="24" rx="2" fill="#0078d4"/>
              <path d="M8.5 8h7v1.5h-7V8zm0 3h7v1.5h-7V11zm0 3h5v1.5h-5V14z" fill="white"/>
            </svg>
            Sync with Outlook
          </button>
        </div>
      </div>

      <!-- Events Section -->
      <div class="events-section">
        <h3>{{ selectedDate | date:'dd MMMM yyyy' }}</h3>
        
        <div class="events-list" *ngIf="selectedEvents.length > 0; else noEvents">
          <div class="event-card" *ngFor="let event of displayedEvents" 
               pTooltip="{{ getEventTooltip(event) }}" 
               tooltipPosition="top"
               [showDelay]="300"
               [hideDelay]="100">
            <div class="event-header">
              <div class="event-title">{{ getEventDisplayTitle(event) }}</div>
              <p-tag class="text-xs" [value]="getEventStatus(event).toUpperCase()"
                     [style]="getStatusTagStyle(event)"
                     style="font-size: 0.7rem !important;">
              </p-tag>
            </div>
            <div class="event-time">
              {{ getEventDateString(event.start) }}
            </div>
            <div class="event-details" *ngIf="event.extendedProps?.['interactionType']">
              <small class="text-gray-600">{{ getInteractionTypeDisplay(event.extendedProps?.['interactionType']) }}</small>
            </div>
          </div>
        </div>
        
        <ng-template #noEvents>
          <div class="no-events">
            <p>No events scheduled for this date</p>
          </div>
        </ng-template>
        
        <div class="view-all-link" *ngIf="hasMoreEvents && !showAllEvents">
          <a (click)="viewAllEvents()">View All ({{ selectedEvents.length - 3 }} more)</a>
        </div>
      </div>
    </div>
  </div>
</div>